import React from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import AdvancedSearchModal from './AdvancedSearchModal';
import { Button, Row, Col } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

class CustomToolbar extends Toolbar {
  render() {
    return (
      <>
        <div className='rbc-toolbar'>
          <span className="rbc-btn-group">
            <Tooltip title="Buscar Agenda el dia de hoy"><Button onClick={() => this.navigate('TODAY')} >HOY</Button></Tooltip>
            <Tooltip title="Dia anterior"><Button onClick={() => this.navigate('PREV')}><span className="lnr lnr-chevron-left" /></Button></Tooltip>
            <Tooltip title="Dia siguiente"><Button onClick={() => this.navigate('NEXT')}><span className="lnr lnr-chevron-right" /></Button></Tooltip>
          </span>
          <span className="rbc-toolbar-label">{this.props.label}</span>
          <span className="rbc-btn-group">
            <Tooltip title="Visualización Mensual"><Button onClick={() => this.view('month')} >MES</Button></Tooltip>
            <Tooltip title="Visualización diaria"><Button onClick={() => this.view('day')}>DIA</Button></Tooltip>
            <AdvancedSearchModal setData={this.props.updateModalEventAppointmentData} referenceDate={this.props.referenceDate} />
            <Tooltip title="Exportar Agenda a PDF"><Button onClick={() => this.props.exportAgendaToPdf()}>
              <FontAwesomeIcon icon={faFilePdf} />
            </Button></Tooltip>
              <Tooltip title="Lista de Admisiones que requieren Reagendamiento"><Button onClick={() => this.props.showRequestReschedule()}>
              <FontAwesomeIcon icon={faCalendarAlt} color={this.props.dataReschedule.length > 0 ? "red" : null} />
            </Button></Tooltip>
          </span>
        </div>
      </>

    );
  }

  navigate = action => {
    this.props.onNavigate(action)
  }
}

export default CustomToolbar;